export default "__VITE_ASSET__46fbb97e__"